/**
 * 地块管理
 */
<template>
  <div class="message">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>Message</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="message-search">
      <el-form-item size="mini" style="margin: 12px auto">
        <el-radio-group v-model="messageType" @change="msgTypeCommand">
          <el-radio-button label="all"></el-radio-button>
          <el-radio-button label="not read"></el-radio-button>
          <el-radio-button label="read"></el-radio-button>
        </el-radio-group>
        <el-button
          type="danger"
          style="margin: 0px 0px 0px 20px"
          @click="deleteSelect"
          >delete</el-button
        >
        <el-button type="primary" @click="markRead">mark read</el-button>
      </el-form-item>

      <el-form-item style="float: right">
        <el-button type="success" icon="el-icon-search" @click="search"
          >Search</el-button
        >
      </el-form-item>
      <el-form-item style="float: right">
        <el-input
          v-model="formInline.searchContent"
          placeholder="Search"
          style="width: 250px"
        ></el-input>
      </el-form-item>
    </el-form>
    <el-form> </el-form>
    <!--列表-->
    <el-table
      ref="messageTable"
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="Loading..."
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="isSelect"
        type="selection"
        width="100"
      >
      </el-table-column>
      <el-table-column align="center" label="State" width="100">
        <template slot-scope="scope">
          <span
            v-if="scope.row.isRead"
            class="iconfont icon-yidu"
            style="color: lightgray"
          ></span>
          <span v-else class="iconfont icon-weidu message-icon"></span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        sortable
        prop="messageType"
        label="Type"
        width="200"
      />
      <el-table-column sortable prop="content" label="Content" width="600" />
      <el-table-column
        align="center"
        sortable
        prop="createTime"
        label="DateTime"
      />
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
  </div>
</template>

<script>
import {
  queryByUserId,
  search,
  deleteMessages,
  markToRead,
} from "../api/message";
import Pagination from "../components/Pagination";
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      formInline: {
        currentPage: 1,
        pageSize: 15,
        searchContent: "",
        userId: localStorage.getItem("userId"),
        readType: 0,
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 15,
        total: 10,
      },
      startTime: null,
      endTime: null,
      messageType: "all",
    };
  },
  // 注册组件
  components: {
    Pagination,
  },

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取通知列表
    getdata(parameter) {
      this.loading = true;
      queryByUserId(parameter)
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            this.listData = res.result.records;
            this.pageparm.currentPage = this.formInline.currentPage;
            this.pageparm.pageSize = this.formInline.pageSize;
            this.pageparm.total = res.result.total;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("Loading Error");
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.currentPage = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      search(this.formInline).then((res) => {
        if (res.status == 200) {
          this.listData = res.result.records;
          this.pageparm.currentPage = this.formInline.currentPage;
          this.pageparm.pageSize = this.formInline.pageSize;
          this.pageparm.total = res.result.total;
        }
      });
    },

    deleteSelect() {
      this.$confirm("Confirm to delete the message?", "Confirm", {
        confirmButtonText: "confirm",
        cancelButtonText: "cancel",
        type: "warning",
      })
        .then(() => {
          // 获取选中行
          var selection = this.$refs.messageTable.selection;
          var selectMessageIdList = selection.map(function (item) {
            return item.messageId;
          });
          deleteMessages(selectMessageIdList).then((res) => {
            if (res.status == 200) {
              this.getdata(this.formInline);
              this.$message({
                type: "success",
                message: "delete successful!",
              });
            }
            else{
              this.$message({
                type: "error",
                message: "delete failed!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "cancel delete",
          });
        });
    },

    markRead() {
      // 获取选中行
      var selection = this.$refs.messageTable.selection;
      var selectMessageIdList = selection.map((item) => item.messageId);
      markToRead(selectMessageIdList).then((res) => {
        if (res.status == 200) {
          this.getdata(this.formInline);
        }
      });
    },

    msgTypeCommand: function (val) {
      this.loading = true;
      switch (val) {
        case "all":
          this.formInline.readType = 0;
          break;
        case "read":
          this.formInline.readType = 1;
          break;
        case "not read":
          this.formInline.readType = 2;
          break;
        default:
          this.formInline.readType = 0;
          break;
      }
      queryByUserId(this.formInline)
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            this.listData = res.result.records;
            this.pageparm.currentPage = this.formInline.currentPage;
            this.pageparm.pageSize = this.formInline.pageSize;
            this.pageparm.total = res.result.total;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("Loading Error");
        });
    },
  },
};
</script>

<style scoped>
.message {
  margin: 0%;
  padding: 30px;
}
.message-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.message-icon {
  color: #f59a23;
}
</style>





// WEBPACK FOOTER //
// src/views/message.vue